import { gql } from '@apollo/client'

import { SIMPLE_USER_FRAGMENT } from '../../../common/graphql/fragments'

const REOPEN_MENU_CURATION_TASK_MUTATION = gql`
  mutation reopenMenuCurationTask($id: ID!) {
    reopenMenuCurationTask(id: $id) {
      id
      taskStatus
      isTierOneDone
      isUnknownWordsCurationDone
      isUnknownWordsQaDone
      isCurationDone
      isQaDone
      isQcDone
      isReopenedManually
      isAvailableForTierOne
      isAvailableForUnknownWordsCuration
      isAvailableForUnknownWordsQa
      isAvailableForCuration
      isAvailableForQa
      isAvailableForQc

      assignedTierOneCurator {
        ...SimpleUserFragment
      }

      assignedCurator {
        ...SimpleUserFragment
      }

      assignedQa {
        ...SimpleUserFragment
      }

      assignedUnknownWordsCurator {
        ...SimpleUserFragment
      }

      assignedUnknownWordsQa {
        ...SimpleUserFragment
      }

      assignedQc {
        ...SimpleUserFragment
      }

      assignedScrapingReviewerUser {
        ...SimpleUserFragment
      }
    }
  }
  ${SIMPLE_USER_FRAGMENT}
`

export default REOPEN_MENU_CURATION_TASK_MUTATION
